import ModalViewMessage from "./modal-view-message"

export default ModalViewMessage